import React from 'react';
import { RecurringSchedule, DAY_NAMES, StaffMember } from './types';
import DayScheduleRow from './DayScheduleRow';

interface RecurringScheduleTabProps {
  schedule: RecurringSchedule;
  staffMembers: StaffMember[];
  selectedStaffId: string;
  onStaffChange: (staffId: string) => void;
  onToggleDay: (dayOfWeek: number, enabled: boolean) => void;
  onAddSlot: (dayOfWeek: number) => void;
  onRemoveSlot: (dayOfWeek: number, slotIndex: number) => void;
  onUpdateSlot: (dayOfWeek: number, slotIndex: number, field: 'startTime' | 'endTime', value: string) => void;
  isLoading: boolean;
}

const RecurringScheduleTab: React.FC<RecurringScheduleTabProps> = ({
  schedule,
  staffMembers,
  selectedStaffId,
  onStaffChange,
  onToggleDay,
  onAddSlot,
  onRemoveSlot,
  onUpdateSlot,
  isLoading,
}) => {
  // Create default schedule if not present
  const getScheduleForDay = (dayOfWeek: number) => {
    return schedule[dayOfWeek] || { isEnabled: false, slots: [] };
  };

  return (
    <div className="py-4">
      {/* Staff Selector */}
      <div className="mb-4">
        <select
          value={selectedStaffId}
          onChange={(e) => onStaffChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#3A5E63] focus:border-[#3A5E63] text-sm"
        >
          {staffMembers.map((staff) => (
            <option key={staff.id} value={staff.id}>
              {staff.name}
            </option>
          ))}
        </select>
      </div>

      {/* Loading State */}
      {isLoading ? (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#3A5E63]"></div>
          <span className="ml-3 text-gray-600">Loading schedule...</span>
        </div>
      ) : (
        /* Day Rows */
        <div className="divide-y divide-gray-100">
          {DAY_NAMES.map((dayName, index) => (
            <DayScheduleRow
              key={index}
              label={dayName}
              dayKey={index}
              schedule={getScheduleForDay(index)}
              onToggle={(key, enabled) => onToggleDay(key as number, enabled)}
              onAddSlot={(key) => onAddSlot(key as number)}
              onRemoveSlot={(key, slotIndex) => onRemoveSlot(key as number, slotIndex)}
              onUpdateSlot={(key, slotIndex, field, value) =>
                onUpdateSlot(key as number, slotIndex, field, value)
              }
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default RecurringScheduleTab;
